import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v0/discounts'


class DiscountsEndpoint extends BaseEndpoint {
    detail(id = null) {
        try {
            return this.client.$get(apiPath + '/' + id, {params: {state: 'detail'}})
        } catch (e) {
            return false
        }
    }

    add(fields) {
        try {
            return this.client.$post(apiPath, fields)
        } catch (e) {
            return false
        }
    }

    update(id = null, fields) {
        if (typeof fields.append !== 'undefined') {
            fields.append('_method', 'PUT')
        } else {
            fields._method = 'PUT'
        }
        try {
            return this.client.$post(apiPath + '/' + id, fields)
        } catch (e) {
            return false
        }
    }

    query(id, data) {
        try {
            return this.client.$post(apiPath + '/' + id + '/query', data)
        } catch (e) {
            return false
        }
    }

    list(params = null) {
        return this.client.$get(apiPath, {params})
    }

}

export default DiscountsEndpoint;
